//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import { handleImgSize } from '@/common/utils/map_view_data'
import CommonFooter from '../_components/_common_footer'
import detailSubPage from '@/common/mixins/detailSubPage'
export default {
    mixins: [
        detailSubPage
    ],
    components: {
        CommonFooter
    },
    data () {
        return {
            items: [],
            building: {}
        }
    },
    computed: {
        price_link () {
            const { house_id, building_id } = this.$route.query || {}
            const { name } = this.building
            return `/building/price?building_id=${building_id}&house_id=${house_id}&title=${name}`
        }
    },
    created () {
        this.getData()
    },
    methods: {
        async getData () {
            const { house_id, building_id } = this.$route.query
            this.building = await Service.getBuilding(building_id)
            const { items } = await Service.getPriceDiagrams(house_id)
            items.forEach((item) => {
                item.diagram_url = handleImgSize(item.diagram_url, 2000)
                item.mini_diagram_url = handleImgSize(item.diagram_url, 320)
            })
            this.items = items
        },
        preview (i) {
            this.$router.push({
                name: 'img_preview',
                query: {
                    url: this.items[i].diagram_url,
                }
            })
        }
    }
}
